$(document).ready(function(){

  


    $('.hm_line_slick_carousel').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      centerMode: true,
      centerPadding: '80px', 
      autoplay: true,
      autoplaySpeed: 1500
  });


    $('.hm_pet_reviews_outer').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/arrow-outline.png?v=1726045770'/></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/arrow-outline.png?v=1726045770'/></button>",
        dots: true,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                arrows: false
              }
            }
        ]
    });


    $('.hm_customers_say_cont').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/arrow-outline.png?v=1726045770'/></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/arrow-outline.png?v=1726045770'/></button>",
        dots: true,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                arrows: false
              }
            }
        ]
    });
});